import React from 'react';
import SiteListItem from '../SiteListItem';
import LogoWP from './logo_wp.svg'; // Tell webpack this JS file uses this image
import LogoDrupal from './logo_drupal.svg'; // Tell webpack this JS file uses this image
import ArrowOpen from './arrow_open.svg'; // Tell webpack this JS file uses this image
import ArrowClose from './arrow_close.svg'; // Tell webpack this JS file uses this image

class SiteList extends React.Component {
  constructor(props) {
    super(props);
    const siteManifest = this.props.manifest;
    const site = this.props.site;
    this.state = {
      site: site,
      siteManifest: siteManifest,
      openReports: false,
    };
  }

  componentDidMount = () => {
    const labels = {
        'largest_contentful_paint': {
            'label': 'LCP',
            'link': 'https://web.dev/lcp/',
            'good_score': 2500,
            'ok_score': 4000,
        },
        'interaction_to_next_paint': {
            'label': 'INP',
            'link': 'https://web.dev/inp/',
            'good_score': 200,
            'ok_score': 500,
        },
        'cumulative_layout_shift': {
            'label': 'CLS',
            'link': 'https://web.dev/cls/',
            'good_score': 0.1,
            'ok_score': 0.25,
        },
    };

    const CrUXApiUtil = {};
    CrUXApiUtil.API_KEY = process.env.REACT_APP_GOOGLE_API_KEY;
    CrUXApiUtil.API_ENDPOINT = `https://chromeuxreport.googleapis.com/v1/records:queryRecord?key=${CrUXApiUtil.API_KEY}`;
    CrUXApiUtil.query = function (requestBody) {
        const requestBodyKey = JSON.stringify(requestBody);
        const cachedResponse = localStorage.getItem(requestBodyKey);
        const cachedTime = localStorage.getItem(requestBodyKey + '_time');

        if (cachedResponse && cachedTime && (Date.now() - cachedTime < 24 * 60 * 60 * 1000)) {
          try {
            return Promise.resolve(JSON.parse(cachedResponse));
          } catch (e) {
            // console.error('Error parsing cached response:', e);
            // Optionally, handle the error further, e.g., by clearing the corrupted cache.
          }
        }

        return fetch(CrUXApiUtil.API_ENDPOINT, {
          method: 'POST',
          body: JSON.stringify(requestBody)
        })
        .then(response => {
            if (response.ok) {
              return response.json();
            }
            if (response.status === 404) {
              // Treat 404 as a valid response, meaning no data available for the URL
              return null;
            }

            return response.json();
        })
        .then(response => {
          if (response) {
            localStorage.setItem(requestBodyKey, JSON.stringify(response));
            localStorage.setItem(requestBodyKey + '_time', Date.now());
          }
          return response;
        })
        .catch(error => {
          // console.error('A network error occurred:', error);
          return null; // or a default object
        });
    };

    let wcvMetrics = null;
    CrUXApiUtil.query({
        origin: this.props.url,
        formFactor: 'PHONE',
    }).then(response => {
        if (response) {
            const wcvData = Object.keys(response.record.metrics).sort().reverse();
            wcvMetrics = wcvData.map((metric) => {
                if (labels[metric] !== undefined) {
                    let scoreClass = 'score ';
                    const score = response.record.metrics[metric].percentiles.p75;
                    if (score >= labels[metric].ok_score) {
                        scoreClass += 'score-red';
                    } else if (score > labels[metric].good_score && score < labels[metric].ok_score) {
                        scoreClass += 'score-orange';
                    } else if (score <= labels[metric].good_score) {
                        scoreClass += 'score-green';
                    }

                    return (<div key={metric} className={scoreClass}>{score}<div className="score-label"><a href={labels[metric].link} target='_blank' rel='noopener noreferrer'>{labels[metric].label}</a></div></div>);
                } else {
                    return null;
                }
            });

            this.setState({
                coreWebVitals: wcvMetrics,
            });
        } else {
            // Handle the case where response is null
            // console.error('No response received');
        }
    }).catch(error => {
        // console.error('Error fetching data:', error);
        // Optionally, update the state or UI to reflect the error
    });
  }


  render() {
    const urlsList = this.state.site.urls.map((url, index) => (
      <SiteListItem
        key={index}
        id={url.id}
        title={url.title}
        url={url.url}
        site={this.state.site}
        siteManifest={this.state.siteManifest}
      />
    ));
    if (
      this.state.coreWebVitals === null
    ) {
      return (
        <main className="content-wrapper">
          <p>Loading core web vitals...</p>
        </main>
      );
    } else {
      return (
        <article
          id={this.props.id}
          className={this.state.openReports ? 'site-list open' : 'site-list'}
        >
          <h2
            onClick={() =>
              this.setState({ openReports: !this.state.openReports })
            }>
            <span>
              {this.props.platform === 'WordPress' ? <img className="platform-logo" src={LogoWP} alt="WordPress" width={20} height={20} /> : <img className="platform-logo" src={LogoDrupal} alt="Drupal" width={20} height={20} />}
              {this.props.name}
            </span>
            {this.state.openReports ? <img className="toggle" src={ArrowClose} alt="Hide Data" width={20} height={20} /> : <img className="toggle" src={ArrowOpen} alt="Show Data" width={20} height={20} />}
          </h2>
          <div className="url-reports">
            {this.state.coreWebVitals ? <div className="core-web-vitals"><h4 className="latest-title">Core Web Vitals (rolling 30 days)</h4><div className="score-cards">{this.state.coreWebVitals}</div></div> : null }
            {urlsList}
          </div>
        </article>
      );
    }
  }
}

export default SiteList;
